import styled from 'styled-components';
export const GalleryContainer = styled.div.withConfig({
  displayName: "gallerycss__GalleryContainer",
  componentId: "sc-136lw2n-0"
})(["margin:", "px;max-width:", "px;width:calc(100% - ", "px);.react-photo-album--photo{position:relative !important;}"], props => props.$spacing, props => props.$containerWidth, props => props.$spacing * 2);
export const GalleryImageWrapper = styled.div.withConfig({
  displayName: "gallerycss__GalleryImageWrapper",
  componentId: "sc-136lw2n-1"
})(["position:relative;overflow:hidden;box-shadow:-1px 3px 6px 1px rgba(0,0,0,0.3);"]);